module.exports = __webpack_public_path__ + "img/girl-down.31d6f3a7.png";